
import Vue from 'vue'
import { formatDate } from '@/utils/dates'
import { isValid, parse, format, formatISO } from 'date-fns'
import { isArray } from 'lodash'

export default Vue.extend({

  props: {
    multiple: { type: Boolean, default: false },
    value: { type: [String, Array], default: () => ([]) },
    prependIcon: { type: String, required: false },
    label: { type: String, required: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    min: { type: String, required: false },
    max: { type: String, required: false },
    hideDetails: { type: [Boolean, String], default: false },
    filled: { type: Boolean, required: false },
    rounded: { type: Boolean, required: false },
    dense: { type: Boolean, required: false },
    range: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    pickerDate: { type: String, default: undefined },
    solo: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    placeholder: { type: String, required: false },
    inputClass: { type: String, default: '' },
  },
  data() {
    return {
      menu: false,
      internalValue: this.value,
      error: '',
    }
  },
  methods: {
    returnValue(value: string | string[]) {
      if (this.multiple) {
        this.internalValue = isArray(value) ? value : [value]
      } else {
        this.internalValue = typeof value === 'string' ? value : value[0] || ''
      }
    },
    updateFromTextField(value: string) {
      this.error = ''
      const parsedDate = parse(value, 'dd/MM/yyyy', new Date())
      if (!value) {
        this.internalValue = this.multiple ? [] : ''
      } else if (isValid(parsedDate) && format(parsedDate, 'dd/MM/yyyy') === value) {
        const formattedDate = formatISO(parsedDate, { representation: 'date' })
        this.internalValue = this.multiple ? [formattedDate] : formattedDate
      } else {
        this.error = 'Format de date : JJ/MM/AAAA'
      }
    },
    clearValue() {
      this.internalValue = this.multiple ? [] : ''
    },
  },
  computed: {
    formattedValue(): string {
      if (this.multiple && isArray(this.internalValue)) {
        return (this.internalValue as string[]).map((date) => formatDate(date, '')).join(', ')
      } else if (typeof this.internalValue === 'string') {
        return formatDate(this.internalValue, '') || ''
      } else {
        return ''
      }
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = newValue
      },
      immediate: true,
    },
    internalValue: {
      handler(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
})
